import { render, staticRenderFns } from "./BatchSuspendForm.vue?vue&type=template&id=6630bbcf"
import script from "./BatchSuspendForm.vue?vue&type=script&lang=js"
export * from "./BatchSuspendForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports